import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { API, api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("ra_admin_token", data?.token ?? "");
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full rounded-xl bg-white/5 border border-[#C5A059]/25 px-4 py-3.5 text-[#F4EEE3] placeholder:text-[#8C8A86] focus:outline-none focus:border-[#C5A059] transition-colors";

  return (
    <div className="min-h-screen bg-[#070F1E] grain flex items-center justify-center px-5 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#C9C3B6] hover:text-[#E3C88A]" data-testid="admin-back-home"><ArrowLeft className="h-4 w-4" /> Back to site</Link>
        <div className="mt-8 rounded-[28px] border border-[#C5A059]/25 bg-[#0A192F]/80 backdrop-blur-xl p-8 sm:p-10">
          <img src="/logo192.png" alt="Ridhanya Associates" className="h-16 w-16 rounded-full" />
          <h1 className="mt-6 font-display text-4xl text-[#F4EEE3]">Enquiry desk</h1>
          <p className="mt-2 text-sm text-[#C9C3B6]">Sign in to review client enquiries.</p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={input} data-testid="admin-email-input" />
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={input} data-testid="admin-password-input" />
            {error && <p className="text-sm text-[#F2A7A7]" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-[#C5A059] py-3.5 font-medium text-[#070F1E] transition-[background-color] hover:bg-[#E3C88A] disabled:opacity-60 inline-flex items-center justify-center gap-2">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
